import { Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const LogoutModal = ({
  isModalOpen,
  handleCancelChange,
  handleConfirmChange,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="custom-modal responsiveModal text-center"
      open={isModalOpen}
      onCancel={handleCancelChange}
      footer={null}
      closeIcon={null}
      centered
      maskClosable={false}
    >
      <div className="gb fs-20  text-center mb-40">
        {t("Are you sure to log out?")}
      </div>

      <div className="yesNoOption">
        <button className="noBtn" onClick={handleCancelChange}>
          {t("Cancel")}
        </button>
        <button className="yesBtn" onClick={handleConfirmChange}>
          {t("Yes")}
        </button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
